import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const resolveImg = (url) => {
  if (!url) return '';
  if (url.startsWith('http')) return url;
  if (url.startsWith('/api')) return `${BACKEND_URL}${url}`;
  return url;
};

export const money = (amount, currency = 'usd') =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: currency.toUpperCase(), maximumFractionDigits: 0 }).format(amount);

export const sizeOptions = (category) => {
  if (category === 'Rings') return ['5', '6', '7', '8', '9', '10'];
  if (category === 'Cuffs') return ['S', 'M', 'L'];
  return null;
};
